import {RestServiceImpl} from "../rest.service.impl";
import {RestService} from "../rest.service.interface";
import {Component, Inject} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {AuthService} from "../../../shared/auth.service";
import {LoggerService} from "../../../shared/logger.service";
import {DropzoneComponent, DropzoneConfigInterface, DropzoneModule} from "ngx-dropzone-wrapper";
import {oase_config} from "../../../../environments/environment";
import {DateiArtDetails} from "../../datei/dateiartdetails.model";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {Datei} from "../../datei/datei.model";
import {Kernantwort} from "../../../shared/response/kernantwort.model";
import {DateiArt} from "../../datei/dateiart.model";
import {Observable} from "rxjs";
import {Httpstatus} from "../../../shared/response/httpstatus.model";
import {APIConfigService} from "../../../api.config.service";
import {ErrorHelper} from "../../../shared/error.helper";
import {AngularMaterial2Module} from "../../../app.module.material";
import {FormsModule} from "@angular/forms";

const PATH_FILE = 'app/protected/immerdrin/bild/images.upload.component.ts';

@Component({
    selector: 'oase-images-upload.dialog',
    templateUrl: './images.upload.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, DropzoneModule ]

})
export class ImagesUploadComponent {

  dateiArtDetails: DateiArtDetails = new DateiArtDetails(); // Wird benötigt da Angular2 nicht auf statische Methoden zugreifen kann!?
  seconddialogrunningajaxcall = false;
  fehlerMain: Kernantwort = null;
  public aktuell = null;
  OBJ_LNG_NAME = null;
  nurBild: boolean = true;
  setDatei: any;
  getDatei: any;

  public dropzoneConfig: DropzoneConfigInterface = null;

    constructor(public dialogRef: MatDialogRef<ImagesUploadComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public _logger: LoggerService)
    {
        this.nurBild = data.nurBild;
        this.aktuell = data.aktuell;
        this.OBJ_LNG_NAME = data.OBJ_LNG_NAME;

		this.setDatei = data.setDatei;
		this.getDatei = data.getDatei;

        this.dropzoneConfig = this.getDropZoneConfig();
        this.setDropzoneTexte();

    }

    getDropZoneConfig() {

	return  {
			url: this.apiConfigService.REST_API_BASE() + 'datei/hinzufuegen',
			maxFiles: 1, // Nur eine Datei kann hochgeladen werden
			uploadMultiple: false, // Mehrfachupload möglich
			parallelUploads: 1, // Wie viele Dateien gleichzeitig hochgelagen werden können
			addRemoveLinks: true,
			acceptedFiles: this.nurBild ? this.dateiArtDetails.BILDEXTENSIONS : this.dateiArtDetails.DOKUMENTEXTENSIONS, // Erlaubte Dateiendungen
			headers: {
				'Authorization': 'Bearer ' + this.authService.getToken() // Den AuthToken beim Bildupload anhängen
			},
			init: function() {
				this.on("processing", function(file: any) {
					console.log(PATH_FILE + ' - DropzoneConfigInterface init on processing file: ', file);
					console.log(PATH_FILE + ' - DropzoneConfigInterface init on processing this.options.url: ', this.options.url);
				});
				this.on("sending", function(file: any, xhr: any, formData: any) {
					console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending file: ', file);
					console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending xhr: ', xhr);
					console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending formData: ', formData);
					console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending this.options.url: ', this.options.url);
				});
				this.on("addedfile", function(file: any) {
					if(this.files.length > 1) this.removeFile(this.files[0]); // Immer nur eine Datei für den Upload ermöglichen: https://github.com/enyo/dropzone/issues/1020#issuecomment-126557207
					if (!file.type.match(/image./)) {
					}
				});
			}
		};

    }

    private onDropModel(args) {
        let [el, target, source] = args;
        // do something else
    }

    private onRemoveModel(args) {
        let [el, source] = args;
        // do something else
    }

    close(): void {
        this.dialogRef.close(false);
    }

	private setDropzoneTexte(): void {
		if (this.nurBild)
			this.dropzoneConfig.dictDefaultMessage=this.translation.translate('dropzone.dictDefaultMessage');
		else
			this.dropzoneConfig.dictDefaultMessage=this.translation.translate('dropzone.dictDefaultMessage_datei');
		this.dropzoneConfig.dictFallbackMessage=this.translation.translate('dropzone.dictFallbackMessage');
		this.dropzoneConfig.dictFallbackText=this.translation.translate('dropzone.dictFallbackText');
		this.dropzoneConfig.dictFileTooBig=this.translation.translate('dropzone.dictFileTooBig');
		this.dropzoneConfig.dictInvalidFileType=this.translation.translate('dropzone.dictInvalidFileType');
		this.dropzoneConfig.dictResponseError=this.translation.translate('dropzone.dictResponseError');
		this.dropzoneConfig.dictCancelUpload=this.translation.translate('dropzone.dictCancelUpload');
		this.dropzoneConfig.dictCancelUploadConfirmation=this.translation.translate('dropzone.dictCancelUploadConfirmation');
		this.dropzoneConfig.dictRemoveFile=this.translation.translate('dropzone.dictRemoveFile');
		//  this.dropzoneConfig.dictRemoveFileConfirmation=this.translation.translate('dropzone.dictRemoveFileConfirmation'); // ist nicht bekannt!
		this.dropzoneConfig.dictMaxFilesExceeded=this.translation.translate('dropzone.dictMaxFilesExceeded');
	}


  dateiHochladen(uploadImageContainer: DropzoneComponent, config: DropzoneConfigInterface) {
    this._logger.log(PATH_FILE + ' - dateiHochladen BEGIN');
    this._logger.log(PATH_FILE + ' - dateiHochladen uploadImageContainer: ', uploadImageContainer);
    // this._logger.log(PATH_FILE + ' - dateiHochladen this.aktuellsprache: ', this.aktuellsprache);

    this._logger.log(PATH_FILE + ' - dateiHochladen config.url: ', config.url);
    this._logger.log(PATH_FILE + ' - dateiHochladen config.url: ', config.url);

    this.seconddialogrunningajaxcall = true;
    uploadImageContainer.config=config;
    uploadImageContainer.directiveRef.dropzone().processQueue();

  } // dateiHochladen

  dateiHochladenOnError(args: any) {
    this.seconddialogrunningajaxcall = false;
    console.log('dateiHochladenOnError:', args);
    ErrorHelper.handleError(args[1], this.nurBild ? "Fehler beim Upload des Bildes": "Fehler beim Upload der Datei", this._logger, this.translation);
  }

  dateiHochladenOnSuccess(args: any) {
	console.log('dateiHochladenOnSuccess:', args);
	let datei: Datei = args[1];
	console.log('dateiHochladenOnSuccess - datei:', datei);
	console.log('dateiHochladenOnSuccess - this.aktuell 1 (geändert):', this.aktuell);
	this.setDatei(datei[0]);
	this.dialogRef.close(false);

	} // dateiAuswaehlen

	isBild(datei) {
	  return datei != null && datei.art == DateiArt[DateiArt.BILD];
	}

	isAlle(datei) {
	  return datei != null && datei.art == DateiArt[DateiArt.ALLE];
	}

  dateiHochladenOnCanceled(args: any) {
    this.seconddialogrunningajaxcall = false;
    console.log('dateiHochladenOnCanceled:', args);
  }

  dateiHochladenProcessQueue(args: any) {
    console.log('dateiHochladenProcessQueue:', args);
  }

    setzeFehler(fehler: Kernantwort) {
        this.fehlerMain = fehler;
    }

}
